/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  document.addEventListener('DOMContentLoaded', function() {
    observeParallaxElements()
  })
}

const observeParallaxElements = () => {
  const parallaxElements = document.querySelectorAll('[data-parallax]')

  if (parallaxElements.length) {
    const updateParallaxElements = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      parallaxElements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top + scrollTop
        if (scrollTop + window.innerHeight > elementTop && scrollTop < elementTop + element.offsetHeight) {
          const parallaxData = element.getAttribute('data-parallax')
          const { y } = JSON.parse(parallaxData)
          const parallaxOffset = 0.15 * (scrollTop - elementTop)

          $(element).css({ backgroundPositionY: `calc(${y}% + ${parallaxOffset}px)` })
        }
      })
    }

    window.addEventListener('scroll', updateParallaxElements)
    window.addEventListener('load', updateParallaxElements)
  }
}
